import React from "react";
import { Button, Col, Container, Form, Modal, Row, Table } from "react-bootstrap";
import { FaStar, FaRegStar } from "react-icons/fa";
import { ratingService } from "../../../services/ratingService";
import { ratingRequest } from "../../../models/ratingRequest";
import { deliveryStatus, deliveryStatusUpdate, httpStatus, orderStatus, paymentMethod, paymentStatus, paymentStatusUpdate, STATUS_TYPES } from "../../../utils/constant";
import { errorAlert, successAlert } from "../../../utils/sweetAlert";
import * as Yup from "yup";
import { ItemOrderDetail } from "../../user/checkout/ItemOrderDetail";
import { formatCurrencyVN } from "../../../utils/common";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { CustomButton } from "../Button";
import { authService } from "../../../services/authService";
import { useNavigate } from "react-router-dom";
const confirmSchema = Yup.object().shape({
    cause: Yup.string()
        .required("Vui lòng nhập lý do"),
});

const updatePasswordSchema = Yup.object({
    oldPassword: Yup.string()
        .required("Vui lòng nhập mật khẩu")
        .min(8, "Mật khẩu phải từ 8 đến 50 ký tự")
        .max(50, "Mật khẩu phải từ 8 đến 50 ký tự")
        .matches(/^[^\s]+$/, "Mật khẩu không được chứa khoảng trắng"),
    newPassword: Yup.string()
        .required("Vui lòng nhập mật khẩu mới")
        .min(8, "Mật khẩu mới phải từ 8 đến 50 ký tự")
        .max(50, "Mật khẩu mới phải từ 8 đến 50 ký tự")
        .matches(/^[^\s]+$/, "Mật khẩu mới không được chứa khoảng trắng"),
    rePassword: Yup.string()
        .required("Vui lòng nhập lại mật khẩu mới")
        .oneOf([Yup.ref('newPassword'), null], "Mật khẩu nhập không khớp")
});

export const ConfirmModal = ({ show, confirm, onClose, handleOperations, input }) => {
    const handleSubmit = (values) => {
        handleOperations(values.cause); // Gửi lý do hủy đơn
    };

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Xác nhận</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{confirm}</p>
                {input && (
                    <Formik
                        initialValues={{ cause: "" }}
                        validationSchema={confirmSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ handleSubmit }) => (
                            <FormikForm onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="cause">
                                    <Field
                                        as="textarea"
                                        name="cause"
                                        rows={3}
                                        placeholder="Tại sao bạn muốn hủy đơn?"
                                        className="form-control"
                                    />
                                    <ErrorMessage name="cause" component="div" className="text-danger" />
                                </Form.Group>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={onClose}>
                                        Không
                                    </Button>
                                    <Button variant="danger" type="submit">
                                        Có
                                    </Button>
                                </Modal.Footer>
                            </FormikForm>
                        )}
                    </Formik>
                )}
                {!input && (
                    <Modal.Footer>
                        <Button variant="secondary" onClick={onClose}>
                            Không
                        </Button>
                        <Button variant="danger" onClick={handleOperations}>
                            Có
                        </Button>
                    </Modal.Footer>
                )}
            </Modal.Body>
        </Modal>
    );
};

const RatingStars = ({ rating, onRate }) => {
    const stars = [1, 2, 3, 4, 5];

    return (
        <div className="d-flex justify-content-center mb-3">
            {stars.map((value) => (
                <span
                    key={value}
                    onClick={() => onRate(value)}
                    style={{ cursor: "pointer" }}
                >
                    {value <= rating ? (
                        <FaStar size={24} color="#f1c40f" />
                    ) : (
                        <FaRegStar size={24} color="#ccc" />
                    )}
                </span>
            ))}
        </div>
    );
};
const ratingSchema = Yup.object().shape({
    content: Yup.string()
        .max(200, "Nội dung không được vượt quá 200 ký tự")
        .required("Vui lòng nhập nội dung nhận xét"),
    star: Yup.number()
        .min(1, "Vui lòng chọn số sao")
        .required("Vui lòng chọn số sao")
});

export const ProductRatingModal = ({
    show,
    handleClose,
    productId,
    userId,
    orderDetailId,
    refetch }) => {

    const handleSubmit = async (values, { resetForm }) => {
        const request = ratingRequest({
            content: values.content,
            star: values.star,
            productId: productId,
            userId: userId,
            orderDetailId: orderDetailId
        });

        const response = await ratingService.addRating(request);
        if (response?.status === httpStatus.CREATED) {
            handleClose();
            refetch();
            successAlert("Thành công", "Đánh giá thành công, cảm ơn sự góp ý chân thành của bạn");
            resetForm();
            return;
        }
        errorAlert("Oops...", "Đánh giá không thành công, đã có lỗi xảy ra!");
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Đánh giá Sản phẩm</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Formik
                        initialValues={{ content: "", star: 0 }}
                        validationSchema={ratingSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleSubmit,
                            setFieldValue,
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col className="text-center">
                                        <RatingStars
                                            rating={values.star}
                                            onRate={(value) => setFieldValue('star', value)}
                                        />
                                        {errors.star && touched.star ? (
                                            <div className="text-danger">{errors.star}</div>
                                        ) : null}
                                    </Col>
                                </Row>
                                <Form.Group controlId="formReview">
                                    <Form.Label>Nhận xét</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="content"
                                        value={values.content}
                                        onChange={handleChange}
                                        placeholder="Nhập nhận xét của bạn ở đây"
                                        isInvalid={!!errors.content && touched.content}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.content}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Button variant="primary" type="submit" className="mt-3">
                                    Gửi Đánh Giá
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </Container>
            </Modal.Body>
        </Modal>
    );
};

export const OrderDetailModal = ({ show, onClose, data }) => {
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Chi tiết đơn hàng (#{data?.id})</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    data?.listOrderDetails.map((orderDetail, idx) =>
                        <ItemOrderDetail key={idx} detail={orderDetail} />
                    )
                }
                <Table bordered className="text-end">
                    <tbody>
                        <tr>
                            <td>Tổng tiền hàng</td>
                            <td>{formatCurrencyVN(data.totalPrice)}</td>
                        </tr>
                        <tr>
                            <td>Phí vận chuyển</td>
                            <td>{formatCurrencyVN(data.deliveryFee)}</td>
                        </tr>
                        <tr>
                            <td>Thành tiền</td>
                            <td className="fs-4 text-danger">{formatCurrencyVN(data.totalPrice)}</td>
                        </tr>
                        <tr>
                            <td>Phương thức thanh toán</td>
                            <td>{paymentMethod[data.payment.paymentMethod]?.displayName}</td>
                        </tr>
                        <tr>
                            <td>Trạng thái thanh toán</td>
                            <td className="text-warning">{paymentStatus[data.payment.paymentStatus]?.displayName}</td>
                        </tr>
                        <tr>
                            <td>Trạng thái đơn hàng</td>
                            <td className="text-secondary">{data.orderStatus}</td>
                        </tr>
                        <tr>
                            <td>Trạng thái vận chuyển</td>
                            <td className="text-secondary">
                                {deliveryStatus[data.deliveryStatus].displayName}
                            </td>
                        </tr>
                        <tr>
                            <td>Đơn vị vận chuyển</td>
                            <td className="text-secondary">{data.deliveryMethod}</td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}
export const OrderEditModal = ({
    show,
    onClose,
    title,
    typeEdit,
    currentValue,
    handleOperations,
}) => {

    const [selectedValue, setSelectedValue] = React.useState(currentValue);
    const [data, setData] = React.useState({});

    React.useEffect(() => {
        switch (typeEdit) {
            case STATUS_TYPES.ORDER:
                setData(orderStatus);
                break;
            case STATUS_TYPES.PAYMENT:
                setData(paymentStatusUpdate);
                break;
            case STATUS_TYPES.DELIVERY:
                setData(deliveryStatusUpdate);
                break;
            default:
                setData({});
                break;
        }
    }, [typeEdit]);

    React.useEffect(() => {
        setSelectedValue(currentValue);
    }, [currentValue]);

    const handleChange = (e) => {
        setSelectedValue(e.target.value);
    }

    const handleSubmit = () => {
        handleOperations(selectedValue);
        onClose();
    }

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Select
                    value={selectedValue}
                    onChange={handleChange}>
                    {
                        data && Object.values(data).map((item, index) => (
                            <option key={index} value={item}>{item}</option>
                        ))
                    }
                </Form.Select>
            </Modal.Body>
            <Modal.Footer>
                <CustomButton className="w-100" onClick={handleSubmit}>Cập nhật</CustomButton>
            </Modal.Footer>
        </Modal>
    )
}
export const ProductAttributesModal = ({
    show,
    onClose,
    title,
    type,
    action,
    currentProductAttribute,
    handleOperations }) => {
    const [productAttribute, setProductActive] = React.useState({
        id: "",
        name: "",
        description: "",
        isActive: false,
    });

    React.useEffect(() => {
        if (currentProductAttribute) {
            setProductActive({
                id: currentProductAttribute?.id || "",
                name: currentProductAttribute?.name || "",
                description: currentProductAttribute?.description || "",
                isActive: currentProductAttribute?.isActive || false,
            });
        }
    }, [currentProductAttribute]);

    const handleChangeNameAttribute = (e) => {
        setProductActive(prev => ({ ...prev, name: e.target.value }))
    }
    const handleChangeDescriptionAttribute = (e) => {
        setProductActive(prev => ({ ...prev, description: e.target.value }))
    }
    const handleChangeActiveAttribute = (e) => {
        setProductActive(prev => ({ ...prev, isActive: e.target.checked }))
    }
    const handleEditAttribute = () => {
        handleOperations(productAttribute)
        setProductActive({
            id: "",
            name: "",
            description: "",
            isActive: false,
        })
    }
    return (
        <Modal
            show={show}
            onHide={onClose}
        >
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Tên</Form.Label>
                    <Form.Control
                        readOnly={action === "view"}
                        type="text"
                        name="name"
                        value={productAttribute.name}
                        onChange={handleChangeNameAttribute}
                        placeholder={action !== "view" && "Nhập tên"}
                    />
                    <Form.Label>Mô tả</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        readOnly={action === "view"}
                        name="description"
                        value={productAttribute.description}
                        onChange={handleChangeDescriptionAttribute}
                        placeholder={action !== "view" && "Nhập mô tả"}
                    />
                    <Form.Check
                        type="switch"
                        disabled={action === "view"}
                        checked={productAttribute.isActive}
                        onChange={handleChangeActiveAttribute}
                        id="active-switch"
                        label={productAttribute.isActive ? "Công khai" : "Khóa"}
                    />
                </Form.Group>
            </Modal.Body>
            {action !== "view" &&
                <Modal.Footer>
                    <CustomButton
                        className="w-100"
                        variant="secondary"
                        onClick={handleEditAttribute}>{action === "create" ? "Thêm" : "Cập nhật"}</CustomButton>
                </Modal.Footer>
            }
        </Modal >
    )
}

export const UpdatePasswordModal = ({ show, onClose }) => {
    const navigate = useNavigate();
    const [formValues, setFormValues] = React.useState({
        oldPassword: "",
        newPassword: "",
        rePassword: ""
    });

    const [errors, setErrors] = React.useState({});
    const [loading, setLoading] = React.useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        updatePasswordSchema.validate(formValues, { abortEarly: false })
            .then(() => {
                return authService.updatePassword({
                    oldPassword: formValues.oldPassword,
                    newPassword: formValues.newPassword
                });
            })
            .then(() => {
                successAlert(
                    "Thành công",
                    "Mật khẩu mới đã được cập nhật thành công. Vui lòng đăng nhập lại",
                    3000,
                    () => navigate("/login")
                );
            })
            .catch((err) => {
                if (err.inner) {
                    const newErrors = {};
                    err.inner.forEach((error) => {
                        newErrors[error.path] = error.message;
                    });
                    setErrors(newErrors);
                } else {
                    const errorMessage = err.response?.data?.message || err.message;
                    console.error(errorMessage);
                    errorAlert("Lỗi", `Yêu cầu thất bại: ${errorMessage}`, 3500);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Cập nhật mật khẩu
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="oldPassword" className="mb-3">
                        <Form.Label>Mật khẩu hiện tại</Form.Label>
                        <Form.Control
                            type="password"
                            name="oldPassword"
                            placeholder="Nhập mật khẩu hiện tại"
                            value={formValues.oldPassword}
                            onChange={handleChange}
                            isInvalid={!!errors.oldPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.oldPassword}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="newPassword" className="mb-3">
                        <Form.Label>Mật khẩu mới</Form.Label>
                        <Form.Control
                            type="password"
                            name="newPassword"
                            placeholder="Nhập mật khẩu mới"
                            value={formValues.newPassword}
                            onChange={handleChange}
                            isInvalid={!!errors.newPassword}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.newPassword}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="rePassword" className="mb-3">
                        <Form.Label>Nhập lại mật khẩu mới</Form.Label>
                        <Form.Control
                            type="password"
                            name="rePassword"
                            placeholder="Nhập lại mật khẩu mới"
                            value={formValues.rePassword}
                            onChange={handleChange}
                            isInvalid={!!errors.rePassword}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.rePassword}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button variant="primary"
                        type="submit" disabled={loading}
                        className="w-100"
                    >
                        {loading ? "Đang cập nhật..." : "Cập nhật mật khẩu"}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal >
    )
}